import { useQueryClient } from '@tanstack/react-query';

import { roomRateAvailabilityQueryKeys } from '~/hooks/apis/reservation/roomRateAvailabilityQueryKeys';

// Rate-plan-wide delete can affect other room types/rates sharing this rate plan, so it invalidates everything
// rather than just this room rate's surcharge key.
export function useInvalidateAllRoomRateAvailability() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: roomRateAvailabilityQueryKeys.all });
}
